import { RoomCard } from "./RoomCard";
import type { Issue, Room } from "../services/db/schema";

interface RoomGridProps {
  rooms: Room[];
  issues: Issue[];
  onOpenRoom: (roomId: string) => void;
  onRenameRoom: (room: Room) => void;
  onDeleteRoom: (room: Room) => void;
}

export function RoomGrid({
  rooms,
  issues,
  onOpenRoom,
  onRenameRoom,
  onDeleteRoom
}: RoomGridProps): JSX.Element {
  return (
    <div className="room-grid">
      {rooms.map((room) => (
        <RoomCard
          key={room.id}
          room={room}
          issues={issues.filter((issue) => issue.roomId === room.id)}
          onOpen={() => onOpenRoom(room.id)}
          onRename={() => onRenameRoom(room)}
          onDelete={() => onDeleteRoom(room)}
        />
      ))}
    </div>
  );
}
